import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { motion } from 'framer-motion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PoliciesPage = () => {
  const { language } = useApp();
  const [policies, setPolicies] = useState(null);

  useEffect(() => {
    fetchPolicies();
  }, []);

  const fetchPolicies = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/policies`);
      setPolicies(data);
    } catch (error) {
      console.error('Failed to fetch policies');
    }
  };

  const getTranslatedText = (textObj) => {
    return textObj?.[language] || textObj?.en || '';
  };

  return (
    <div data-testid="policies-page" className="min-h-screen pt-32 pb-24">
      <div className="container mx-auto px-6 max-w-4xl">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl md:text-5xl font-serif tracking-tight mb-12">
            {language === 'ro' ? 'Politici' : language === 'fr' ? 'Politiques' : 'Policies'}
          </h1>

          <Tabs defaultValue="privacy" className="w-full">
            <TabsList className="w-full justify-start border-b border-white/10 bg-transparent p-0 h-auto mb-8">
              <TabsTrigger
                value="privacy"
                data-testid="tab-privacy"
                className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none bg-transparent px-6 py-3"
              >
                {language === 'ro'
                  ? 'Politica de Confidențialitate'
                  : language === 'fr'
                    ? 'Politique de Confidentialité'
                    : 'Privacy Policy'}
              </TabsTrigger>
              <TabsTrigger
                value="terms"
                data-testid="tab-terms"
                className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none bg-transparent px-6 py-3"
              >
                {language === 'ro' ? 'Termeni și Condiții' : language === 'fr' ? 'Termes et Conditions' : 'Terms & Conditions'}
              </TabsTrigger>
              <TabsTrigger
                value="cancellation"
                data-testid="tab-cancellation"
                className="data-[state=active]:border-b-2 data-[state=active]:border-primary rounded-none bg-transparent px-6 py-3"
              >
                {language === 'ro'
                  ? 'Politica de Anulare'
                  : language === 'fr'
                    ? 'Politique d\'Annulation'
                    : 'Cancellation Policy'}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="privacy">
              <div className="prose prose-invert prose-lg max-w-none">
                <p className="text-lg leading-relaxed text-muted-foreground whitespace-pre-line">
                  {policies ? getTranslatedText(policies.privacy_policy) : ''}
                </p>
              </div>
            </TabsContent>

            <TabsContent value="terms">
              <div className="prose prose-invert prose-lg max-w-none">
                <p className="text-lg leading-relaxed text-muted-foreground whitespace-pre-line">
                  {policies ? getTranslatedText(policies.terms_conditions) : ''}
                </p>
              </div>
            </TabsContent>

            <TabsContent value="cancellation">
              <div className="prose prose-invert prose-lg max-w-none">
                <p className="text-lg leading-relaxed text-muted-foreground whitespace-pre-line">
                  {policies ? getTranslatedText(policies.cancellation_policy) : ''}
                </p>
              </div>
            </TabsContent>
          </Tabs>
        </motion.div>
      </div>
    </div>
  );
};

export default PoliciesPage;